import script from "./WorkloadGlanceEndpoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkloadGlanceEndpoints.vue?vue&type=script&setup=true&lang=ts"

import "./WorkloadGlanceEndpoints.vue?vue&type=style&index=0&id=0c17779a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c17779a"]])

export default __exports__